import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaLock } from "react-icons/fa";
import "./work.css";

const WorkItems = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (item.link) {
      window.open(item.link, "_blank");
    }
  };

  const responsibilityBadge = (id) => {
    const badgeMap = {
      1: {
        text: "Software Development",
        bgColor: "bg-yellow-50",
        textColor: "text-yellow-800",
        ringColor: "ring-yellow-600/20",
      },
      2: {
        text: "UI/UX Design",
        bgColor: "bg-green-50",
        textColor: "text-green-700",
        ringColor: "ring-green-600/20",
      },
      3: {
        text: "Product Design",
        bgColor: "bg-blue-50",
        textColor: "text-blue-700",
        ringColor: "ring-blue-700/20",
      },
      4: {
        text: "Project Management",
        bgColor: "bg-indigo-50",
        textColor: "text-indigo-700",
        ringColor: "ring-indigo-700/20",
      },
    };

    const badge = badgeMap[id];
    return badge ? (
      <span
        className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${badge.bgColor} ${badge.textColor} ${badge.ringColor}`}
      >
        {badge.text}
      </span>
    ) : null;
  };

  return (
    <motion.div
      className=" bg-white border border-black/10 p-5 rounded-2xl flex flex-col gap-4 cursor-pointer"
      key={item.id}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      whileHover={{ scale: 1.05 }}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(!item.link && true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={item.image}
        className="w-full h-36 md:h-72 object-cover rounded-xl"
      />
      {isHovered && !item.link && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-700 bg-opacity-80 text-white text-center p-4 rounded-2xl">
          <p className="text-xs md:text-sm">
            I have signed a non-disclosure agreement (NDA) that prohibits me
            from sharing any designs or developments related to this project.
          </p>
        </div>
      )}
      <div className="flex flex-col gap-2 w-72">
        <h3 className="w-full truncate">{item.title}</h3>
        <div className="flex gap-2">
          {responsibilityBadge(item.responsibility)}
          {!item.link && (
            <span class="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10 gap-1">
              <FaLock />
              NDA
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default WorkItems;
